import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlertService } from '../../services/alert.service';
import { PermissionService } from '../../services/permission.service';
import { Router } from '@angular/router';
import { MdlManageCampaign } from '../../components/mdl-manage-campaign/mdl-manage-campaign';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MdlManageSegment } from '../../components/mdl-manage-segment/mdl-manage-segment';
import { Api } from '../../services/api';

@Component({
  selector: 'app-segments',
  imports: [FormsModule, CommonModule],
  templateUrl: './segments.html',
  styleUrl: './segments.css'
})
export class Segments {
  private api = inject(Api);
  segmentos: any[] = [];
  showRecentDropdown: boolean = false;
  selectedItem: string = 'todas';
  campanasFiltradas: any[] = [];
  activeFilters: any = null;
  searchTerm: string = '';
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  errorMessage: string = '';
  isLoading: boolean = true;
  openedMenuId: string | null = null;

  readonly dialog = inject(MatDialog);

  constructor(
    private alertService: AlertService,
    public permissionService: PermissionService,
    private router: Router
  ) {
    this.initializeFilters();
    this.cargarSegmentos();
  }

  cargarSegmentos(): void {
    this.api.showLoading();

    this.api.getSegmentos().subscribe({
      next: (response: any) => {
        this.segmentos = response.segmentos || [];
        this.api.hideLoading();
        console.log('segments::: ', response.segmentos);
      },
      error: (error: any) => {
        this.errorMessage = 'Error al cargar los segmentos. Por favor, intenta nuevamente más tarde.';
        this.api.hideLoading();
      }
    });
  }

  openMdlCharts(): void {
    // Logic to open the charts modal
  }

  openFilterModal(): void {
    // Logic to open the filter modal
  }

  toggleRecentDropdown(): void {
    this.showRecentDropdown = !this.showRecentDropdown;
  }

  selectItem(key: string): void {
    this.selectedItem = key;
    this.showRecentDropdown = false; 
  }

  openMdlCreateCampaign(): void {
    // Logic to open the create campaign modal
  }

  private initializeFilters(): void {
    if (!this.activeFilters) {
      this.activeFilters = {
        allCompanies: true,
        allPositions: true,
        allStatus: true,
        creationDateRange: 'all',
        phoneFilter: 'all',
        emailFilter: 'all',
        companies: {},
        positions: {},
        status: {}
      };
    }
  }

  clearFilters(): void {
    this.activeFilters = null;
    this.searchTerm = '';
    this.sortColumn = '';
    this.sortDirection = 'asc';
    this.initializeFilters();
    this.campanasFiltradas = [...this.segmentos];
    this.alertService.success('Filtros limpiados', 'Los filtros han sido limpiados');
  }

  hasActiveFilters(): boolean {
    if (!this.activeFilters) return false;
    
    const hasCompanyFilter = !this.activeFilters.allCompanies && 
      Object.values(this.activeFilters.companies).some(val => val === true);
    const hasPositionFilter = !this.activeFilters.allPositions && 
      Object.values(this.activeFilters.positions).some(val => val === true);
    const hasStatusFilter = !this.activeFilters.allStatus && 
      Object.values(this.activeFilters.status).some(val => val === true);
    const hasDateFilter = this.activeFilters.creationDateRange !== 'all';
    const hasPhoneFilter = this.activeFilters.phoneFilter !== 'all';
    const hasEmailFilter = this.activeFilters.emailFilter !== 'all';
    
    return hasCompanyFilter || hasPositionFilter || hasStatusFilter || hasDateFilter || hasPhoneFilter || hasEmailFilter || this.searchTerm.trim() !== '';
  }

  onSearchChange(): void {
    if (!this.searchTerm.trim()) {
      if (this.activeFilters) {
        this.applyAdvancedFilters();
      } else {
        this.campanasFiltradas = [...this.segmentos];
      }
    } else {
      const searchLower = this.searchTerm.toLowerCase().trim();
      this.campanasFiltradas = this.segmentos.filter(prospecto => 
        prospecto.nombre?.toLowerCase().includes(searchLower) ||
        prospecto.apellido?.toLowerCase().includes(searchLower) ||
        prospecto.cargo?.toLowerCase().includes(searchLower) ||
        prospecto.empresa?.toLowerCase().includes(searchLower) ||
        prospecto.telefono?.includes(searchLower) ||
        prospecto.email?.toLowerCase().includes(searchLower) ||
        prospecto.estado?.toLowerCase().includes(searchLower) ||
        prospecto.ejecutivo?.nombre?.toLowerCase().includes(searchLower) ||
        prospecto.ejecutivo?.apellido?.toLowerCase().includes(searchLower)
      );
    }
    
    if (this.sortColumn) {
      this.applySorting();
    }
  }

  private applyAdvancedFilters(): void {
    let filteredProspects = [...this.segmentos];

    if (!this.activeFilters.allCompanies) {
      const selectedCompanies = Object.keys(this.activeFilters.companies).filter(key => this.activeFilters.companies[key]);
      if (selectedCompanies.length > 0) {
        filteredProspects = filteredProspects.filter(prospecto => 
          selectedCompanies.includes(prospecto.empresa)
        );
      }
    }

    if (!this.activeFilters.allPositions) {
      const selectedPositions = Object.keys(this.activeFilters.positions).filter(key => this.activeFilters.positions[key]);
      if (selectedPositions.length > 0) {
        filteredProspects = filteredProspects.filter(prospecto => 
          selectedPositions.includes(prospecto.cargo)
        );
      }
    }

    if (!this.activeFilters.allStatus) {
      const selectedStatus = Object.keys(this.activeFilters.status).filter(key => this.activeFilters.status[key]);
      if (selectedStatus.length > 0) {
        filteredProspects = filteredProspects.filter(prospecto => 
          selectedStatus.includes(prospecto.estado)
        );
      }
    }

    if (this.activeFilters.creationDateRange !== 'all') {
      filteredProspects = this.filterByCreationDate(filteredProspects, this.activeFilters.creationDateRange);
    }

    
    if (this.activeFilters.phoneFilter !== 'all') {
      filteredProspects = this.filterByPhone(filteredProspects, this.activeFilters.phoneFilter);
    }

    
    if (this.activeFilters.emailFilter !== 'all') {
      filteredProspects = this.filterByEmail(filteredProspects, this.activeFilters.emailFilter);
    }

    this.campanasFiltradas = filteredProspects;
    
    if (this.sortColumn) {
      this.applySorting();
    }
  }

    private filterByCreationDate(prospects: any[], dateRange: string): any[] {
    const hoy = new Date();
    
    switch (dateRange) {
      case 'today':
        return prospects.filter(prospecto => {
          if (!prospecto.fecha_creacion) return false;
          const fechaCreacion = new Date(prospecto.fecha_creacion);
          return fechaCreacion.toDateString() === hoy.toDateString();
        });
      
      case '7d':
        const sieteDiasAtras = new Date(hoy);
        sieteDiasAtras.setDate(hoy.getDate() - 7);
        return prospects.filter(prospecto => {
          if (!prospecto.fecha_creacion) return false;
          const fechaCreacion = new Date(prospecto.fecha_creacion);
          return fechaCreacion >= sieteDiasAtras && fechaCreacion <= hoy;
        });
      
      case '30d':
        const treintaDiasAtras = new Date(hoy);
        treintaDiasAtras.setDate(hoy.getDate() - 30);
        return prospects.filter(prospecto => {
          if (!prospecto.fecha_creacion) return false;
          const fechaCreacion = new Date(prospecto.fecha_creacion);
          return fechaCreacion >= treintaDiasAtras && fechaCreacion <= hoy;
        });
      
      default:
        return prospects;
    }
  }

  private filterByPhone(prospects: any[], phoneFilter: string): any[] {
    switch (phoneFilter) {
      case 'withPhone':
        return prospects.filter(prospecto => prospecto.telefono && prospecto.telefono.trim() !== '');
      case 'withoutPhone':
        return prospects.filter(prospecto => !prospecto.telefono || prospecto.telefono.trim() === '');
      default:
        return prospects;
    }
  }

  private filterByEmail(prospects: any[], emailFilter: string): any[] {
    switch (emailFilter) {
      case 'withEmail':
        return prospects.filter(prospecto => prospecto.email && prospecto.email.trim() !== '');
      case 'withoutEmail':
        return prospects.filter(prospecto => !prospecto.email || prospecto.email.trim() === '');
      default:
        return prospects;
    }
  }

  sortByColumn(column: string): void {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    this.applySorting();
  }

  private applySorting(): void {
    if (!this.sortColumn) return;

    this.campanasFiltradas = [...this.campanasFiltradas].sort((a, b) => {
      let valueA = this.getSortValue(a, this.sortColumn);
      let valueB = this.getSortValue(b, this.sortColumn);

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      }
      if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }

  private getSortValue(prospecto: any, column: string): any {
    switch (column) {
      case 'nombre':
        return `${prospecto.nombre} ${prospecto.apellido}`.toLowerCase();
      
      case 'cargo':
        return prospecto.cargo?.toLowerCase() || '';
      
      case 'empresa':
        return prospecto.empresa?.toLowerCase() || '';
      
      case 'telefono':
        return prospecto.telefono || '';
      
      case 'email':
        return prospecto.email?.toLowerCase() || '';
      
      case 'estado':
        return prospecto.estado?.toLowerCase() || '';
      
      case 'ejecutivo.nombre':
        return `${prospecto.ejecutivo?.nombre || ''} ${prospecto.ejecutivo?.apellido || ''}`.toLowerCase();
      
      default:
        return prospecto[column] || '';
    }
  }

  verDetalleCampana(campanaId: number, event: Event): void {
    event.stopPropagation();
    // Logic to navigate to campaign detail view
  }

  toggleActionsMenu(id: string): void {
    this.openedMenuId = this.openedMenuId === id ? null : id;
    this.showRecentDropdown = false; 
  }

  openManageSegmento(): void {
    this.dialog.open(MdlManageSegment, {
      minWidth: '750px',
      minHeight: '600px',
      data: {
        mode: 'add'
      },
      panelClass: 'mat-dlg-class'
    });
  }

  openMdlDeleteCampana(campanaId: number): void {
    // Logic to open delete campaign modal
  }

  openNewChangeOwner(campana: any): void {
    // Logic to open change owner modal
  }

  openCampaigns(): void {
    this.router.navigate(['/campaigns']);
  }
}
